module.exports = __webpack_public_path__ + "static/media/poco-log.19e36d2b.png";